<template>
  <district-blank-form
    submit-label="Добавить район"
    :district="district"
    :errors="errors"
    form-type="add"
    @submit="processDistrictForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { addDistrict } from '@/services/district.service'
import districtBlankForm from '@/components/forms/district/DistrictBlankForm'

export default {
  name: 'district-add-form',
  components: { districtBlankForm },
  props: {
    city: {
      type: [Number]
    }
  },
  data () {
    return {
      district: {
        id: null,
        name: '',
        city: this.city
      },

      errors: {
        district: {
          id: [],
          name: [],
          city: []
        }
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processDistrictForm () {
      this.addDistrict().then((success) => {
        if (success) {
          this.showMsg('Район был успешно добавлен!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    addDistrict () {
      return addDistrict(this.district).then((response) => {
        this.district = response.data
        this.fillErrors(this.errors.district, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.district, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.showMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// DistrictAddForm.vue?9cc4abe0